import { Dialog, IconButton } from '@mui/material';
import Clear                  from '@mui/icons-material/Clear';
import IosShare               from '@mui/icons-material/IosShare';
import { FC }                 from 'react';
import styled                 from 'styled-components';
import { Share }              from '@capacitor/share';

const FullScreenDialog = styled(Dialog)`&& {
  .MuiDialog-paper {
    background    : #000;
    width         : 100%;
    height        : 100%;
    max-width     : 100%;
    max-height    : 100%;
    margin        : 0;
    border-radius : 0;
    display       : flex;
    flex-direction: column;
  }
}` as any;

const TopBar = styled.div`
  display         : flex;
  align-items     : center;
  justify-content : space-between;
  padding         : 8px 4px;
  background      : rgba(0, 0, 0, 0.85);
  flex-shrink     : 0;
  padding-top     : max(8px, env(safe-area-inset-top));
`;

const Content = styled.div`
  flex       : 1;
  overflow   : hidden;
  display    : flex;
  align-items: center;
  justify-content: center;
`;

const PreviewImage = styled.img`
  width      : 100%;
  height     : 100%;
  object-fit : contain;
`;

const PreviewFrame = styled.iframe`
  width  : 100%;
  height : 100%;
  border : none;
`;

interface IFilePreviewModalProps {
  url         : string;
  uri         : string;
  contentType : string;
  onClose     : () => void;
}

export const FilePreviewModal: FC<IFilePreviewModalProps> = ({ url, uri, contentType, onClose }) => {
  const isImage = contentType.startsWith('image/');
  const isPdf   = contentType === 'application/pdf';

  const handleShare = () => Share.share({ files: [ uri ] });

  return (
    <FullScreenDialog open fullScreen onClose={onClose}>
      <TopBar>
        <IconButton size="large" style={{ color: '#fff' }} onClick={onClose}>
          <Clear />
        </IconButton>
        <IconButton size="large" style={{ color: '#fff' }} onClick={handleShare}>
          <IosShare />
        </IconButton>
      </TopBar>

      <Content>
        { isImage && <PreviewImage src={url} alt="preview" /> }
        { isPdf   && <PreviewFrame src={url} title="preview" /> }
      </Content>
    </FullScreenDialog>
  );
};
